export const autoLabelDatabase = [
    {
        idCode: 'ea^P@@@LdbVRRbbvRRbLVRbrTVRdsRuMTmSSMLuSPEdEaLWEiATSUCRu]_QKPW@M]gIhM]GIdC]cAdvAnqirXcW^rZ`wXtYLqkkYMp[lYLfDuvlfdMvMfSJFzBKImC]cCdqanqbrZpwTpYLx[hKLf|MvMVSAFzBSIhm]cUdc]AQdvVnqbqQnqnrZhwXsYLukl[MuklYLMkjXMMklZLmklXMlklxyWQuvnqisrn}oe][@j{VaUtlcklX]bknXeWTuJnqf]]c]n]]cM`',
        coordinates: '!BmpJH@oy?mwvH_[\\Bb@Jw_Xa}mpK~_x`B?g~w_Xa}mpJH@k]}bGw~_{\\Bb@JH__x@b@JH_X`BbGw~@H`BbGvH@ha}?`BH@ha}b@K~@Ha}',
        mf: 'C40H56',
        mw: 536.88464,
        label: 'Lycopene',
    },
    {
        idCode: 'eaYP@@@LdbbTbsbrTVRTVRbrbbdWBaOKUMUMLtsSMLuUU@RTVdyAVUUCRu]_tEpCWVrZCWZrYCW^r[CWXrXcWRrZ`wXpyLqkhyMqkjYLH[l[lfdMvLvSJZ{fSZZ{NSFF{FCIkC]cSdsanqhr[pwXrYLD[l[LfbMvLVSIFzfCIlc]cUdqVnqjuVnqbsVnqlwVnqdpvni`tvnqhrvnq`vrnsce]GWZ{FgOJ{v~UulBkmZEWXrJnel]]cCbU]STz{F{Lz{F[\\j{f@',
        coordinates: '!B?`BH_[]}mpJH?H`BmpIt^pnGmwvH_X`B?g~H_X`BbGvH@oy?bGvH@ha}b@JH__x@b@JH_X`BbGw~@H`BbGw~_x`BbGvw_Xa}f~atnH`B',
        mf: 'C40H56',
        mw: 536.88464,
        label: 'beta-carotene',
    },
    {
        idCode: 'eghP@@@LddTTVdRVbLf|VRgEdbgfPRUUUUUUUUUUUW@B`RDhbb\\ST@~P`aBOt^PAnshFzNP{lXMawXtXcnqiuG]cEfF{vx[mXQnqiN{FSJ]vMft{lZlYw\\pZqnmgFzV|[jXKnqntW]cCdn{F[YMwLUwTtzkniasW]SAnnzfSC]uMFf{j[LmwTq[[nijqw]S]knzf[@',
        coordinates: '!BmwvH__x@?g~w@oy??g~H@k\\B?`@_YSF?bGvH_Xa}Gqhq`ELXb@KxF}MgYVBw?Cctm?vw?K_}m?s~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Cucurbitane',
    },
    {
        idCode: 'eghP@@@LddTbbtVdIVbdsRdabcfefSUUUUUUUUUUUW@D`bDh`bbbR@~PPbbOt^PAnchN{FKHMv]`w^qG]cCjN{FsL]vMVx{nXLIwXpZSnqhrc][Z]vMvL{lYMYwXsYqnuoF{FB{lZ]EwTpYInelfzfJ{jYMUwTtYinynnzfgC]uLNf{j[LmwTq[[nijqw]S]knzf[@',
        coordinates: '!BmpJH@oy??`C~@A}eL[~H__x@bGt_Fh`BTqc~_x`B?`AeXHa}bGvw?Cctb@KxF}Mgm?vw?K_}m?s~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Dammarane',
    },
    {
        idCode: 'eghP@@@LddTTVbTad|VLVR`fdea`VUUUUUUUUUUUUW@B`UBxRdBST@~P`bbOt^PCnq`tC]gHMvm`wXqG]cSjFzNX{lZMpwRpc][RMuLiwXq[Qn}cN{FSVMwLywTt{sniapW]cYhn{FkI]wLFr{l[lUwXpzknqfsW]SAnnzfSC]uMFf{j[LmwTq[[nijqw]S]knzf[@',
        coordinates: '!BmpK~_x`B?`Bw__x@bGvw_Xa}mpK~_{\\Bb@KxF}Mg?`@_YSF?Gqhq`ELXYVBw@cctm?vw@k_}mpK~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Lanostane',
    },
    {
        idCode: 'eghP@@@LddTbbtVdIVbdsRdabcfefSUUUUUUUUUUUW@B`RBhPbbbR@~PPbbOtnPAnchN{FKHMv]`w^qG]cCjN{FsL]vMVD{lXMIwXtYQnmmN{F{F]vLfl{lYlxwZwc]cA]vMNb{jXLdwRvS]SE]uLfj{jZLtw\\wW]SSanzfGS]uMfV{jXmmwTuX{ninuw]SM`',
        coordinates: '!BmpJH@oy??`C~@A}eL[~H__x@bGt_Fh`BTqc~_x`B?`AeXHa}bGvw@cctb@KxF}Mgm?vw@k_}mpK~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Protostane',
    },
    {
        idCode: 'egdP@@@LddTQdVeRdtVLVRgD`bfag`VUUUUUUUUUUUUUp@jHICHy@du@OhCHQy@FzV`[mYAnylNzfgD]uLNh{lXLpwVwC]SBMv]HwXrg]cSmF{vL[hzsnqhsg]cEoN{FSA]vMfb{lZlew\\p[KnqnqW]cCjn{F[M]uLFz{jYLMwTtZ[nilrw]SEmnzfkG]uMvn{jYl',
        coordinates: '!BmpJH@o`[tv_~@K]}?`Bw@h`B?`Bw@k]}?`Bw@k\\B?`@_YSF?Gqhq`ELXYVBw@cctm?vw@k_}mpK~_p',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Cycloartane',
    },
    {
        idCode: 'egdP@@@LddTbbtVbtVtT|R`ebf`QVWVquUUUUUUUUUUTh@hHaJDIMHDhitidA}`aEDQQ~cr@]vMf`{lXlawXp{CnqdqG]SMjFzNX{lZmqwTwXSnqntg]cSeN{FcZMv\\Xw^ug]cMgNzfS^]uLNB{jXMEwXpYKnijvS][E]uMFj{nXLuwTt{inuaf{Ff[iY[nibvs]SGMwM]wTvX',
        coordinates: '!B?l]klaRrW`@TcVnM?l]kc_{XEHtTlo{GZ{IklalMZ{HTc_{GEHw~vAL|HgS~qqRrEHtAmqRMEKK~qp',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Friedelane',
    },
    {
        idCode: 'egdP@@@LddTbbtVadLTRltdabce`VSPvuUUUUUUUUUUUpAHHaAEhgIt`OdDHDc}Gd@{lXm@wQrG]cYlN{FkD]uMvh[lyan}nNzf[B]vLNd{lYLiwXs[Snq`qg]cQkFzv\\{l[mywXtxInuhf{FR{jZmewTrXkniauW]SAfnzfc]MtlLwTtw]sAenzfg[MwL]wTqZ{nilp',
        coordinates: '!BbGw~@K]}?g~H@oy??`Bw@h`BmpJH__x@bGvw_Yg@?g~H@ox@nuSOsURDotzH_Xa}bGwIPH`BuB^KAp',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Lupane',
    },
    {
        idCode: 'egdP@@@LddTbbtVdLJtRdvdabcedQPwVuUUUUUUUUUUUpAHHHmIELet`OhMHQy@FzN`{lXl`wYvC]{D]uLvh{l[LqwXu[cninpg]cAiN{FcJMumiwXpxsnqdug]cMgF{V|[lXKnijtW]c]dn{FgYMtlTwTuW]SIfnzfG]]uLFF[nZ[nibrw]SYmnzfcG]wLFn{jZ\\',
        coordinates: '!BmpJH@oy??`C~@K]}?g~H__x@bGvw@h`BmpK~_x`B?`Bw__x@bGvH_[\\BCwvw@h`BuB^KA?x@vuPlf@',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Oleanane',
    },
    {
        idCode: 'egdP@@@LddTbbtVadLTRvtdabce`UTpvuUUUUUUUUUUUHAHHaAIhgIyJet`OdDHDc}Gd@{lXm@wQrG]cYlN{FkD]uMvh[lyan}nNzf[B]vLNd{lYLiwXs[Snq`qg]cQkFzv\\{l[mywXtxInuhf{FR{jZmewTrXkniauW]SAfnzfg]MtlLwTtw]SQen{fC[MwL]wTqZ{nilp',
        coordinates: '!BRGw~`C]}?k}H@oz??`@w@d`BMpIH__z@RGtw__z@?k}H@ox@MpKwoS\\Bb@IH_Ta}?hC~@D`BANmSip',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Taraxastane',
    },
    {
        idCode: 'egdP@@@LdbTbbTVbbQvdjteB`e`QVSRvsUUUUUUUUUUTH`lIQAIH`hdidA}AaGzOHAwXvZCnqdrG]cElN{FGD]vMFh[hycnqjwG]S]aN{F{R]vMNT[l{Qn}cNzf[V]vLv\\{jYMywTpxKni`tW]SSdn{FCYMulUwTtZkny`sS]k]MvLMwTuZYneefzfv[nX{nibuw]SY`',
        coordinates: '!BR@K~os\\BRGuH_S]}?k|w__z@?k?~o?x@MpHw@o^}MpJH@da}RGw~`Ox@?k}H@ox@RGuH_T`BANmSip',
        mf: 'C30H50',
        mw: 410.727,
        label: 'Ursane',
    },
    {
        idCode: 'ek`P@@@LddTTVbvebQbrbbxtdlL\\BRjjjjjjjjjjk`APJaJQqYSj@_XPQQBd_i\\`G]cAhF{NP[m[AnqbN{FgTMt\\qwXt[anmaFzVd[jYSnqbvc]{F]vLfl[nYsnqlwg]cU`n{F{Q]vLNR{lYmewTpXkniduW]SQfnzfs]]uLVF{jZmMwTpy[ninvw]SMcnzfg@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw?Cctm?vw?K_}?`Bw?Oy?Stp',
        mf: 'C29H52',
        mw: 400.73187999999993,
        label: 'Poriferastane',
    },
    {
        idCode: 'ek`P@@@LddTTVbvebQbrbbxtdlL\\BRjjjjjjjjjjk`APJaJQqYSi@_XPQQBd_i\\`G]cAhF{NP[m[AnqbN{FgTMt\\qwXt[anmaFzVd[jYSnqbvc]{F]vLfl[nYsnqlwg]cU`n{F{Q]vLNR{lYmewTpXkniduW]SQfnzfs]]uLVF{jZmMwTpy[ninvw]SMcnzfg@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw?Cctm?vw?K_}?`Bw?Oy?Stp',
        mf: 'C29H52',
        mw: 400.73187999999993,
        label: 'Stigmastane',
    },
    {
        idCode: 'ekdPD@@@LLdTbRbRUTRtrTfVXTxDl\\RrZzvNjjjjjjjjjjjbHDPkET`Oz[IAwTrYCnifqG]SAjNzfsL]uMVx{lYlIwXwZSnihrg]SEmNzf{F]vMVl{l[LywXq[snqdpW]cChfzNR{lZMdwYqS]{U]vLFZ[k[inuaf{Ff{lZ\\lwRvs]SGMwL',
        coordinates: '!BgF_GS_ygnOiwSb|fnOeBRwiXe?U?IdIKnOfx~fSR?badSVSMYCK~YvQMYDw~YvPr?aadSVQMYCH',
        mf: 'C27H44O2',
        mw: 400.64435999999995,
        label: 'Spirostane',
    },
    {
        idCode: String.raw `fc@@@LddTTVbvebQbrbgMRlYpTuUUUUUUUUUW@JBheQrsNhGvHQREQ~atAwXpZC]gH[m[C]cD{lZ]Qncf]vMFxwVpfzVdwTrn{FKZ[oXw]cIkMwL{nqlwn{FkA{l[mGnqar^{F[Y{jXLWnidu^zfcM{j[Mwnibp~zfkS{jX\oninv~zf[@`,
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@k]}?`Bw@oy?',
        mf: 'C28H50',
        mw: 386.705,
        label: 'Campestane',
    },
    {
        idCode: String.raw `fc@@@LddTTVbvebQbrbgMRlYpTuUUUUUUUUUW@JBheQrsNpGvHQREQ~atAwXpZC]gH[m[C]cD{lZ]Qncf]vMFxwVpfzVdwTrn{FKZ[oXw]cIkMwL{nqlwn{FkA{l[mGnqar^{F[Y{jXLWnidu^zfcM{j[Mwnibp~zfkS{jX\oninv~zf[@`,
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@k]}?`Bw@oy?',
        mf: 'C28H50',
        mw: 386.705,
        label: 'Ergostane',
    },
    {
        idCode: 'ec`PH@@@LdTTRRTVVbfQdrvEG@g`USRvuUUUUUUUUUUXTKaEHC~frP]vLvP{jYMawXwXcnqjuG]SAfNzfs\\]vMfD{lXmIwTtYSnibvg]cIcN{FGVMt\\ywTu[snqhpS]gQMwlewTw[KnifqW]cAjfzvZ[m[inqan{FgSMtllwTvs]s@',
        coordinates: '!BtJW~hNpx{D_Pfd_ltJWPfak`esvhPox@jCvWPj`}jDK~gy\\}?bBhOZ`}?i~hPoz`jCvhOZaB',
        mf: 'C27H46O',
        mw: 386.66124,
        label: 'Furostane',
    },
    {
        idCode: 'eglPD@@@MlbbbbbRRqfbbbRRsDbeagaSPqrusP@PAE@D@HPP@@_tNrCWYrY@wYrZM`[hyMFHMtlfcTZ{FSLV{FCIhwFncdpfnedtanq`rYSWTr[SWZrXsW^rZsW\\rYsWXp[sWVrXKWRtZHwXpZLeklzMdkiXkWQtZiWZsRnsne]cCJ{ffUt\\lkkXyWTurn}`',
        coordinates: '!B?`Bw@h`B?`Bw__x@bOvw?H`BmpJH@h`Bm?w~@Hc}mpJH@ox@m?w~@Hc}b@Jw@k\\Bb@JH@ox@m?vH?P',
        mf: 'C28H18O2',
        mw: 386.44892,
        label: 'Bisanthrone',
    },
    {
        idCode: 'fmo@@@LddTTVbvebQbrTyjUcNBfjjjjjjjjjh@Oz[PCFCPirJmbcDXtzdNXqhwIlJKRdrfLVu]cLYMZsNXv[sFkAXwZKFGIXs[JfCETrZjfcMTv[jfKCTuZZf{KTsX',
        coordinates: '!BetK~gzaBM`BWO_z`esvhOZ`}etK~gy]BjDK~hL~esyhqXNLxi]BWP`QLesvWPi\\}?i~WP`',
        mf: 'C27H48',
        mw: 372.67812,
        label: 'cholesterol',
    },
    {
        idCode: 'fmo@@@LddTTVbvebQbrTyjUcNBfjjjjjjjjji`EATRhyY`OlPbdJc}MhCnq`tF{NPwZvF{FIwXtzc]GL{lZMqnmaMtmInie]vLVtw^qn{FSV[nYw]cYo]vMVCwXwZO]cCd}vLvswTpXo]SIj}uMF[wTv[o]SEa}uMVgwTwY_]SM`',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@k]}mpK~_p',
        mf: 'C27H48',
        mw: 372.67812,
        label: 'Cholestane',
    },
    {
        idCode: 'fa{@@@LddTTVbvebQbwMRlYpTuUUUUUUUUL@hJbUGKLA}bDTaT_hM@]vLF`wYrF{VpwXqN{FgT[hyg]cQnMulIneiMuLknqbvf{vMwXrZs]sN{l[M{nqjp^{F{Q{lX\\gnqfv^zfCE{jYMWnihs^zfs]{jXl',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@`',
        mf: 'C24H42',
        mw: 330.59748,
        label: 'Cholane',
    },
    {
        idCode: 'fj}@p@@FmxI\\dTTTRbTRR~XJSdyhJHBb`JCBDqB`OlHadBc}@hAnqh]t]FPwTvNzVcD[hzg]cIfMwMqnuaMtmIn}e]ulfuwTrYs][Q{mYLgnydv^zVS@',
        coordinates: '!BbOvw?_y?bOrw?Oy?bGvw_Xc}m?w~@K]}?g~H@oy?bOrw?K\\B?`Bw@`',
        mf: 'C15H14O6',
        mw: 290.27016000000003,
        label: 'Flavan-3,4-diol',
    },
    {
        idCode: 'fjc@@@LddTTVbvebQyjUcNBfjjjjjjjj`EATRhy@~qBJPjOtj`N{FCP[lyC]kX[lXg]cSjMt\\snqhwFzvDwRtfzfUwXq[S]{F{lYMYnyg]vMf}wXuXO]c]h}vLNSwXs[O]SAb}uMF@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYV@x}@',
        mf: 'C21H36',
        mw: 288.51684,
        label: 'Pregnane',
    },
    {
        idCode: 'fj}@p@@LDhI\\bbbbbfqbRvxKUdyZBhb@`JAFEq@~QbNQ~`T`wRrNzVcX[nXg]GQjMvmqniaMvMIncmMul[nqduf{v]wVr[w]SIh}vlfSw\\r[O]KI`',
        coordinates: '!B?`BH@k\\B?`BH_[]}?`Bw?Hc|?g~H@k_|bOvw?_x@bOrw?K\\B?`Bw@`',
        mf: 'C15H12O6',
        mw: 288.25428,
        label: 'Dihydroflavonol',
    },
    {
        idCode: String.raw `fj}@p@@DEiI\bbbfbTtQRQXHwhyZdJH@BJ@@OzARC]KH[n[G]KQjMuLsnchwF{VDwXtn{FSJ[hxs][V{kYL{nidwf{vCwZrZO]sIl}tlf@`,
        coordinates: '!B?`Bw@h`Bmww~@Ox@bGvH?K_|bOs~_x`Bm?w~@Hc}m?rw@hc|?`Bw@`',
        mf: 'C15H10O6',
        mw: 286.23839999999996,
        label: 'Flavonol',
    },
    {
        idCode: 'fbmAP@@Fm{NRJJJIQJYIy`iNbf`h`JHB`PaLPOdHad_hE@MvMCnchrFzfqwRtXc]GT{lYLqnynMvlIneiMwlknmdvnzfSN[kXO]kIh}wLfSwRrX',
        coordinates: '!BbOvw?_y?bOrw?Oy?bGvw_Xc}m?w~@K]}?g~H@hc|m?rw@ox@mpH',
        mf: 'C15H14O5',
        mw: 274.27116,
        label: 'Flavan-3-ol',
    },
    {
        idCode: 'fbmAP@@\\e{NQQQJJKFIKYgEFbehJH`HB``q@~`rOtBdFzVQwRt[C]sD{hzMQnufMuMqnqaMt\\inmm]vLfLw^unzvSN{jYLGnudt^{fSI{iYL',
        coordinates: '!B?`BH@k\\B?`BH?_x@m?rH?Oy?b@Jw?Hc}m?w~@Hc|m?rw@ox@mpH',
        mf: 'C15H12O5',
        mw: 272.25527999999997,
        label: 'Flavanone',
    },
    {
        idCode: 'fbmAPD@\\}GHIrQQQQQHiQItDXKd`PP@ADP@@_tB`F{F`wTrNzNcX[nXg]cIj]tmFXwQpfzVewVrYW]SImMvlYn}k]vlf]w\\rXK][I{iYL',
        coordinates: '!Bm?vH?_y?m?s~_xc|mwvH_[_}?`BH_Xc}m?rw@oy?b@JH?Ox@mpH',
        mf: 'C15H11O5',
        mw: 271.24734,
        label: 'Anthocyanidine',
    },
    {
        idCode: 'fbmAP@@\\e{NQQQJJKFIKYgEFbehFH`HB`@C~`T`wRrNzVcX[nXg]GQjMvlqninMvLInceMumknqdqf{vmwVrYw]SI`}vlfcw\\rYO]KI`',
        coordinates: '!B?`BH@k\\B?`BH?_x@mpJH@oy?b@Jw@hc}m?w~@H`BmpJw@ox@mpH',
        mf: 'C15H10O5',
        mw: 270.2394,
        label: 'Flavone',
    },
    {
        idCode: String.raw `fluhP@DTxIPCQSdTRbbUTRRSNRT{sUKMUUUP@_t\dIlbcXjqIMR{LbwKMJGJivfMrlinSdmr|ynPVmr@`,
        coordinates: '!B?oum~QKy?ouBuo{}Dog]aYkMPlg~_ySz^bTT~Rc~?cK~eQKz',
        mf: 'C10H13N5O4',
        mw: 267.24422,
        label: 'deoxyguanosine',
    },
    {
        idCode: 'fbm@`@@HRY[UfUWISrXyZjj@@@H@@heHMv]ancb]v\\fiwQrYc]{\\{oYLInqi]vLfTwVvfzfMwVrZw]SIgMvmyny`}vlfcw\\rYK]KY{iYL',
        coordinates: '!BFfASFF@ZKAc~@Hc}b@K~_xc}m?vH?_y?b@K~_?y?bOvH?Xc}b@H',
        mf: 'C18H18O2',
        mw: 266.33892,
        label: 'Butyrolactone',
    },
    {
        idCode: 'fb}@`@@FrQQJIIIHsIDiHvgIsUPTE@@T@@_tRdF{vQwYr[C]cD[hzg]GIfMumqniaMv]Kn}drf{Vtw\\un{FSN[i[w][I`}uLfcwZrYO]sIl}tlf@',
        coordinates: String.raw `!Bb@J{UHc}f\CRtOy?b@KRtIg@bOvH?[mTs}JH@f]SLXCOtl?RLX@`,
        mf: 'C18H18O2',
        mw: 266.33892,
        label: 'Furanofuran lignan',
    },
    {
        idCode: 'fb}@`@@HRY[efuWHrRoIcejjh@@@h@@heHMv]ancb]v\\fhw^sNzNS\\{kYLInqi]wlfUwXr[W]kIcMumYnig]uLf}wRrXK]kQ[nYO]sIlmtl',
        coordinates: '!BFfASFF@ZKAbH?_x@b@K~_x`B?`BH?[_}bOvH@h`B?g?~_xc}bOt',
        mf: 'C18H16O2',
        mw: 264.32304,
        label: 'Arylnaphthalene lactone',
    },
    {
        idCode: 'flm@@@LddTTVbvebyjUcNBfjjjjjjj@C~fT@q`tJ\\bkXhqFMNiCfLZMr[BbtiLicEmWXsFSVlsfMf|qjpVMvbqarVLv@',
        coordinates: '!BetK~gzaBM`BWO_z`esvhOZ`}etK~gy]BjDK~hL~esyhqXNLx',
        mf: 'C19H32',
        mw: 260.46308,
        label: 'steroid',
    },
    {
        idCode: 'flm@@@LddTTVbvebyjUcNBfjjjjjjjhAPUDjNPOlPbdJc}LhCnq`tF{NPwZvF{FIwXtzc]GL{lZMqnmaMtmInie]vLVtw^qn{FSV[nYw]cYo]vMVCwXwZO]cCd}vLv@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELX',
        mf: 'C19H32',
        mw: 260.46308,
        label: 'Androstane',
    },
    {
        idCode: 'fle@P@@\\\\eIfVWyWyZCEhFB@`H@Pi_t|dF{NQwXr[C]GD{jYMSnmdsF{vEw\\rZW]kIeMvMknedqfzvlwTwf{VBw\\tVzV@',
        coordinates: '!B?`BH@k\\BbGw~@Ox@?g~H@hc|m?s~@K_}?`BH?K_|mpK~@K\\B',
        mf: 'C15H12O4',
        mw: 256.25628,
        label: 'Chalcone',
    },
    {
        idCode: 'fluA@@@ISLrrn~QchaSUTDD@A@@G}DiCn}drF{vqwXrXg]GIjMvLqncn]ulfEwTrZW]gIeMuminicMv][nudsn{fS^[mXK]sQ{iYLene`',
        coordinates: '!BsA_LZNU_HNkeHBCeEOm?VVcSEOa?IfcLyU?eW~T`yRA?VW|f',
        mf: 'C18H20O',
        mw: 252.35579999999996,
        label: 'Monofuranic lignan 7-O-7′',
    },
    {
        idCode: 'fluA@@@ISKJn}jRfkQSUPTD@A@@G}DiAn}d]v\\fpwXqFzNiwQrYc][\\[jXS]gR{oYLinumMwL[nqdufzV]wVr[w]SI`}vlfcw\\rYO]KI`',
        coordinates: String.raw `!BG@\\^LE?lEjpIY\]fOwhw^cBp^?A{~c]fOw~{~cBzMwhw^cB`,
        mf: 'C18H20O',
        mw: 252.35579999999996,
        label: 'Monofuranic lignan 7-O-9′',
    },
    {
        idCode: 'fluA@@@IRjkLjo`chaSUUP@@A@@G}DiCnsdrF{NqwQrXc]GT{oYLqn}n]vLfDwXtnzvSJ{jYMinmcMuM[nudsn{fS^[mXK]sQ{iYLene`',
        coordinates: '!BKA`lYvAeXAjH@ha}bGw~_?y?b@Jw_Xa}bGvH__y??g~H@ha}',
        mf: 'C18H20O',
        mw: 252.35579999999996,
        label: 'Monofuranic lignan 9-O-9′',
    },
    {
        idCode: 'fdei`@LZlFHIJrQQQSIQEYDhZw`uUUPHEP@G}GIAc\\dI[ebgDTwJcfyLZwKdVECmVXuVm]gR[tvCQ`',
        coordinates: '!Bj?dT~_x@^bTEI_xrO]ZZtozUDoim~_{|i]Im~fwz?os~?@',
        mf: 'C10H13N5O3',
        mw: 251.24521999999996,
        label: 'deoxyadenosine',
    },
    {
        idCode: 'fdu@@@LddTRtjTrSA\\dZpXuUUUUUUT@hJddmHGqHQRIQjOtR`N{FsP{lXlcnqdvN{F{D{lX]Qncf]vMVywXtXW]cMiMv\\in}m]vLFLwVuf{V\\wXwfzVBwTtV{f@',
        coordinates: '!B?g~H?A|ZLPBH_Q}ebOuSYx`B?g~H_Xc}?g~H@hc}bGvH?@',
        mf: 'C18H30',
        mw: 246.43619999999999,
        label: 'Estrane',
    },
    {
        idCode: 'fhiQP@DX@IW`yEEDeDdbdsakMUMMUU@ASRPdrJMbsDfuFMrYEnUZRfyFRwJsfyNZwH',
        coordinates: '!B@yhCi_xl@yk~_pNZ?brT~ghe?bpCfaSyJO{~LozUDoh',
        mf: 'C10H14N2O5',
        mw: 242.23016,
        label: 'deoxythymidine',
    },
    {
        idCode: String.raw `fdy@@@DjU^{yVg@qBBJj@@@@he@]vLfawVrYG]SIl]wlfIwZrZg]sIf]t\fywRrXS]GR{lyLin}mMv\YnqkMulynioMvlEnyhmtl`,
        coordinates: String.raw `!B?g~H@k\BbOvH?[_}b@K~_{\BbOvw?_y?m?vH?_y??g~H?P`,
        mf: 'C18H22',
        mw: 238.37267999999997,
        label: 'Dibenzylbutane',
    },
    {
        idCode: String.raw `fde@@@LdbbTRtVRKIBTFHQEDE@D@AQJ@{kYMCnqdrN{VSX[oXg]SIj]wlfYwRr[c]cB[hzW]sIe]t\ftwVqfzflwYsn{NS^[mXK]sQ[iX`,
        coordinates: '!B?`BH?[_}b@Jw@h`B?g~w@hc}m?vw?Xc}GvT_Foy??g~H?P',
        mf: 'C18H20',
        mw: 236.35679999999996,
        label: 'Arylnaphthalene',
    },
    {
        idCode: String.raw `fde@@@LdbbbTRVQpcZ][t@DDDUA@AQJ@[kZG]SIdMvManub]vLfiw\rYc]S\[oXS]KR{kYLkn}dvnzVSF[nZs]GN{mYM{ncdpV{NcwYrX`,
        coordinates: '!B?g~[iBAzfyl`AWh`_?yzHGi__?yzWrAzfyl`AYndKwHoCP',
        mf: 'C18H20',
        mw: 236.35679999999996,
        label: 'Dibenzocycloctane',
    },
    {
        idCode: 'fhe@@@LdbbbTReryHQmN|Fjjjjjj`@iE@TzCFCHavFMFIUjTYcFK\\npfLfeMeQ[TfLqlufMV]YoL[lEcM`',
        coordinates: '!BbOvw?_x@?g~H@k\\B?g~w@k_}bOvH?_x@GvVH@a|ZTq`',
        mf: 'C17H28',
        mw: 232.40931999999998,
        label: 'steroid core',
    },
    {
        idCode: 'fhe@@@LdbbbTReryHQmN|Fjjjjjjj@TDaLadCz`HaBHYAhRJ@[lzG]cAdMt]cnqhqF{VhwXsN{FK\\[oXW]cIiMulinemMuL[nqlun{FkN[n[w]c]`}vLv@',
        coordinates: '!BbGvw__x@?g~H@k\\B?g~w?K_}bOvH__x@GvVH?A|ZTq`',
        mf: 'C17H28',
        mw: 232.40931999999998,
        label: 'Gonane',
    },
    {
        idCode: 'f`qQP@DX@ISoILrl{jsfcMUMMUT@G}MIBSHhvKLR[TXwIdVyUiJ[eiK\\cN[eYk\\`',
        coordinates: '!B@yhCi_xl@yk~_pNZ?brT~ghe?bpT~Rc~?cK~eQKz',
        mf: 'C9H12N2O5',
        mw: 228.20328,
        label: 'deoxyuridine',
    },
    {
        idCode: 'f`qpP@DXxBSoYEDhihTdjBtYijjji`@iiHRYEfqQbQZdvXqnPjliS\\mI[dYs\\kM[d',
        coordinates: '!B@yk~K@Ne@yhCfoy??bpCiYSz^bTT~Rc~?cK~eQKz',
        mf: 'C9H13N3O4',
        mw: 227.21921999999998,
        label: 'deoxycytidine',
    },
    {
        idCode: 'fhy@`@@BrJJJJIPy[`eV|EhJ`@@`@C~`T`wRrNzVcX[nXg]GQjMvlsnqdwFzfDwXtfzNTwVvnzvSF{jYMYn}g]vlf}w\\rXO]KI`',
        coordinates: '!B?`BH@k\\B?`BH_[]}?`Bw@h`Bb@K~_{\\BbGvw_[]}mpH',
        mf: 'C15H12O2',
        mw: 224.25827999999998,
        label: 'Isoflavanone',
    },
    {
        idCode: 'fhy@`@@JRYfYU_XhwgAZd@`@H@@hEHMtlanyl]tmFIwXrZc]SL{hzMqnua]ulfewTrYS]cZ[hxs][V{mYL{nydwf{vCwRrX',
        coordinates: '!B?`Bw@h`Bm?w~@Ox@bOw~_{\\Bb@JH@h`Bm?vw?Xc}mpH',
        mf: 'C15H10O2',
        mw: 222.24239999999998,
        label: 'Isoflavone',
    },
    {
        idCode: 'f`i@`@@VRYfYU]`eNMyh@`AB@@OzNrBnsdZ{NcXut]FIkiZMQWXsC]cAhwE]GBuvLFdkiYRnimJ{VLkoYrnyoJzv@',
        coordinates: '!B?g~w_Xa}?g~w@oy?b@JH_[]}mwvH_Xa}?g~w@h`B',
        mf: 'C14H8O2',
        mw: 208.21552,
        label: 'Anthraquinone',
    },
    {
        idCode: 'foQ@`@@BRYfYWvBUXsf`B@@`@C~cl`klyFnshvM]GQbZzVcTUvLpwXpZMqWQpm]cAiJzVTkj[RnucJ{vlknYrnm`',
        coordinates: '!B?g~w?Xc}?g~w@oy?b@JH?[_}m?vH?Xc}mpJH@`',
        mf: 'C13H8O2',
        mw: 196.20452,
        label: 'Xanthone',
    },
    {
        idCode: 'foQA@@@YEEEEDdbrRkF\\t@D@D@@_t]dE]gHuv]FqkhzLSWRtZbnqfF{FCQnJzNDkiZVnq`re]SZUvlYW^ue]sNUul',
        coordinates: '!B?g~w?Xc}?g~w@oy?b@Jw?Xc}m?vH?Xc}mpJH@`',
        mf: 'C14H10O',
        mw: 194.23239999999998,
        label: 'Anthrone',
    },
    {
        idCode: 'dg|@@DjU_eZx{BAH@@BJozN`]vLfcnmdr]uLfsnilq]vlfknyds]vMf{nedpmvMK][JwTvmvl[]sVwRp',
        coordinates: '!B?`Bw?Xc}mpJw?Hc|m?vH?_y?bOrH?Xc}b@H',
        mf: 'C14H12',
        mw: 180.24928,
        label: 'Stilbene',
    },
    {
        idCode: 'fgA@@@DjYU_VByHu`@@@@@@OzNpFnshtM]KQdJ{NpklXfnq`uE]KLut]FxkjXQnq`tZRnyeJzNtkmXrn}kJzv@',
        coordinates: String.raw `!B?g~H@k\BbOvw?Xc}m?vH@k\Bb@JH?Xc}b@H`,
        mf: 'C14H10',
        mw: 178.2334,
        label: 'Anthracene',
    },
    {
        idCode: 'dclD@@UIfV][iuhFAH@OzJdMtlg]KQl[nXnzNcTwZsMuMs]cBwQtmumk]{@',
        coordinates: '!B?`BH@k\\B?`BH?_x@mpJH@h`B?`BH?P',
        mf: 'C10H6O2',
        mw: 158.15563999999998,
        label: 'Naphtoquinone',
    },
    {
        idCode: 'dmLD@@QIe[VfeVi@B@C~`iC]SHwXvMwMS]K\\wQpmvmK]{JwVp',
        coordinates: '!Bb@JH?_x@b@JH@ox@bOvH@h`BbOt',
        mf: 'C9H6O2',
        mw: 146.14463999999998,
        label: 'Coumarin',
    },
    {
        idCode: 'dazH`Jx@aJ]nji`dG}JPGJQap|T\\MGGBaIppP',
        coordinates: '!B?g~H@k_}?g~H?[_}?g|',
        mf: 'C5H11NOS',
        mw: 133.21434,
        label: 'methionine',
    },
    {
        idCode: 'detH@@rQQJHtpsPT@`AQTAnqh{hzLc]SYwRtXfzNinyf[i[f{VEn}i[kX',
        coordinates: '!BbOvw?_y?b@K~_{_}bOvH?X`B',
        mf: 'C9H8O',
        mw: 132.16152,
        label: '2H-Chromene',
    },
    {
        idCode: 'daDD@@qJYnnjjh@htQcIkESUKM[]s@',
        coordinates: '!Bm?vH?[_|?g?~_x`BbOt',
        mf: 'C6H12O2',
        mw: 116.15928000000001,
        label: 'pyranose',
    },
    {
        idCode: 'gOp`AdifMjj`OzVIcJVMM^Yzp',
        coordinates: '!BTv]`YW?~KF_~_q`l',
        mf: 'C5H10O2',
        mw: 102.1324,
        label: 'furanose',
    },
    {
        idCode: 'gOp`Adigkjj`OzVIcKVMMYY|p',
        coordinates: '!Bm?vH?[_|?g?~_xc}',
        mf: 'C5H10O2',
        mw: 102.1324,
        label: 'pyranose core',
    },
    {
        idCode: 'gFp`AdidvjhC~abXrecSWf@',
        coordinates: '!BTv]`YW?~KF_~_p',
        mf: 'C4H8O2',
        mw: 88.10552,
        label: 'furanose core',
    },
];
//# sourceMappingURL=autoLabelDatabase.js.map